<template>
    <client-page>
        <v-container class="container--large">
            <auction-program-header v-model="program" v-bind="{ _program }" />
        </v-container>
        <v-container>
            <div class="tab-wrap">
                <auction-program-groups :value="group" v-bind="{ program }" />
            </div>
            <div>
                <auction-program-search v-bind="{ totalCount }" />
                <auction-work-list :works="works" class="gallery-card-row" />
            </div>

            <div class="v-pagination-wrap">
                <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-8 mb-16" @input="(page) => $router.push({ query: { ...this.$route.query, page } })" />
            </div>
        </v-container>

        <v-fade-transition leave-absolute>
            <v-overlay v-show="loading" color="white" light>
                <v-progress-circular color="primary" indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </client-page>
</template>

<script>
import api from "@/api";
import { WORK_AUCTION_MODES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import AuctionWorkList from "@/components/client/auction/auction-work-list.vue";
import AuctionProgramHeader from "@/components/client/auction/programs/auction-program-header.vue";
import AuctionProgramGroups from "@/components/client/auction/programs/auction-program-groups.vue";
import AuctionProgramSearch from "@/components/client/auction/programs/auction-program-search.vue";

export default {
    components: {
        ClientPage,
        AuctionWorkList,
        AuctionProgramHeader,
        AuctionProgramGroups,
        AuctionProgramSearch,
    },
    props: {
        _program: { type: String, default: null },
        group: { type: String, default: "all" },
    },
    data: () => ({
        loading: false,

        program: null,
        works: [],

        totalCount: 0,
        limit: 20,
    }),
    computed: {
        sort() {
            return this.$route.query.sort || "lot_asc";
        },
        searchKey() {
            return this.$route.query.searchKey || null;
        },
        searchValue() {
            return this.$route.query.searchValue || null;
        },
        page() {
            return +this.$route.query.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        headers() {
            const { skip, limit } = this;
            return { skip, limit };
        },
        params() {
            const { _program, group, sort, searchKey, searchValue } = this;

            const params = { mode_auction: WORK_AUCTION_MODES.PROGRAM.value, _program, group, sort, searchKey, searchValue };

            if (group == "all") delete params.group;

            return params;
        },
    },
    mounted() {
        this.init().then(this.search);
    },
    watch: {
        params() {
            this.init().then(this.search);
        },
    },
    methods: {
        async init() {
            this.works = [];
            this.totalCount = 0;

            let path = `/auction-programs/${this._program}/groups/${this.group}`;
            if (this.$route.path != path) this.$router.replace({ path, query: this.$route.query });
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { headers, params } = this;
                var {
                    summary: { totalCount },
                    works,
                } = await api.v1.auction.works.gets({ headers, params });

                this.works = works;
                this.totalCount = totalCount;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
